module.exports = __webpack_public_path__ + "img/kangjiatun1.d326b729.png";